import Vue from 'vue'
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import api from '@reserve/api'
import { IEDate } from '@appbase/util';
import { mapGetters, mapMutations } from 'vuex';
import * as types from '@reserve/store/types'
import * as accountTypes from '@account/store/types'

@Component({
    computed: mapGetters({
        user: accountTypes.USER,
        selectedResources: types.SELECTED_RESOURCE_KEYS,     
        category: types.CALENDAR_CATEGORY
    }),

    methods: {
        ...mapMutations({
            setCategory: types.CALENDAR_CATEGORY
        })
    }
})
export default class ResourceSelectionPane  extends Vue {
    @Prop({ type: String }) initCompany!: string;
    @Prop({ type: String }) initCategory!: 'FAVORITE' | 'EWS' | 'DB';
    @Prop({ type: String }) initResource!: string | null;
    @Prop({ type: String }) eventStart!: string;
    @Prop({ type: String }) eventEnd!: string;
    @Prop({ type: String }) eventStartTime!: string;
    @Prop({ type: String }) eventEndTime!: string;
    @PropSync('selectedResource', { type: Object }) selectedResourceSync!: ewsResource.EwsResourceItem | reserve.DbResourceItem | null;

    setCategory!: (payload: 'FAVORITE' | 'EWS' | 'DB') => void;

    user!: account.User;
    selectedResources!: string[];
    category!: 'FAVORITE' | 'EWS' | 'DB';  

    curCategory: 'FAVORITE' | 'EWS' | 'DB' = 'FAVORITE'; 
    curResourceGroup: string | null = null;
    curResourceItem: string | null = null;      
    resourceGroup: reserve.ResourceItemBase[] = [];
    resourceItems: reserve.ResourceItemBase[] = [];    

    onCheckResource: boolean = false;
    mMailUser: boolean = false;

    @Watch('category')
    onCategoryChanged(newVal: 'FAVORITE' | 'EWS' | 'DB') {             
        this.mountResources(this.initCompany, newVal, null)       
    }

    @Watch('curResourceGroup')
    onCurrentResourceGroupChanged(){  
        var setStart = IEDate(`${this.eventStart} ${this.eventStartTime}`);
        var setEnd = IEDate(`${this.eventEnd} ${this.eventEndTime}`);
        this.updateAvailableResources(setStart, setEnd);       
    }

    @Watch('curResourceItem')
    onCurrentResourceItemChanged() {
        console.log('itemChanged', this.curResourceItem)
        this.syncSelectd();
    }

    @Watch('eventStart')
    @Watch('eventEnd')
    @Watch('eventStartTime')
    @Watch('eventEndTime')
    onTimeSelectionChanged() {          
        var setStart = IEDate(`${this.eventStart} ${this.eventStartTime}`);
        var setEnd = IEDate(`${this.eventEnd} ${this.eventEndTime}`);
        this.updateAvailableResources(setStart, setEnd);
    }

    created() {
        if(this.user.isMailUser) {
            this.mMailUser = true;
        }

        this.curCategory = this.initCategory == null ? this.category : this.initCategory;      
        this.initCompany = this.initCompany == null ? this.user.comCode : this.initCompany; 
     
        this.mountResources(this.initCompany, this.curCategory, this.initResource)
    }

    async mountResources(initCompany: string, initCategory: 'FAVORITE' | 'EWS' | 'DB', initResource: string | null): Promise<reserve.ResourceItemBase[]> {             
        this.onCheckResource = true;

        if(initCategory === 'FAVORITE') { 
            this.curResourceGroup = null;
            this.resourceGroup = [];        
        } else {
            this.resourceGroup = await api.resource.getResourceGroups(initCompany, initCategory);    
            
            if(this.resourceGroup.length == 0) {      
                this.mountCallback([], initResource); 
                this.onCheckResource = false;             
                return Promise.resolve([]);               
            }
        }

        let availableParam = initResource == null && initCategory !== 'FAVORITE' ? 
            <reserve.AvailableResourceRequest> {
                comCode: initCompany,
                groupId: this.resourceGroup[0].uniqueId,
                groupIncludeAddress: null,
                itemStore: initCategory,
                start: IEDate(`${this.eventStart} ${this.eventStartTime}`),
                end: IEDate(`${this.eventEnd} ${this.eventEndTime}`)
            } :
            <reserve.AvailableResourceRequest> {
                comCode: initCompany,
                groupId: null,
                groupIncludeAddress: initResource,
                itemStore: initCategory,
                start: IEDate(`${this.eventStart} ${this.eventStartTime}`),
                end: IEDate(`${this.eventEnd} ${this.eventEndTime}`)
            }

        return api.resource.getAvailableRooms(availableParam).then(res => {  
            if(this.curCategory == 'FAVORITE') {
                this.curResourceGroup = null;
            } else {
                if(initResource != null) {
                    var found = res.find(r => r.address === initResource);
                    this.curResourceGroup = found?.parentId || this.resourceGroup[0].uniqueId;
                } else {
                    this.curResourceGroup = this.resourceGroup[0].uniqueId;
                }   
            }
                                   
            this.mountCallback(res, initResource);           
            return res;               
        }).finally(() => {
            this.onCheckResource = false;
        }); 
    }

    mountCallback(res: reserve.ResourceItemBase[], selectResource: string | null) {        
        this.resourceItems = res;

        if(this.resourceItems.length > 0) {
            if(selectResource != null || this.selectedResources.length == 1) {
                let selectedResource: reserve.ResourceItemBase | undefined = undefined;
    
                if(selectResource != null) {
                    selectedResource = res.find(r => r.address === selectResource);
                } else {
                    selectedResource = res.find(r => r.uniqueId === this.selectedResources[0]);   
                }
    
                if(selectedResource) {             
                    this.curResourceItem = selectedResource.uniqueId;                
                } else {                    
                    this.curResourceItem = res[0].uniqueId;
                }                                        
            } else {          
                this.curResourceItem = res[0].uniqueId;
            }   
        }                     

        this.syncSelectd();
    }

    onCategorySelectionChanged() {
        this.setCategory(this.curCategory);
    }

    updateAvailableResources(start: Date, end: Date) {            
        if(this.initCompany == null || this.curResourceGroup == null || this.onCheckResource)
            return;                
        
        this.onCheckResource = true;                        
        var checkAvailable: boolean = !(
            ((end.getTime() - start.getTime())/(1000 * 60) > 1440) && 
            this.curCategory === 'EWS'
        );               

        api.resource.getAvailableRooms({ 
            comCode: this.initCompany,
            groupId: this.curResourceGroup,
            groupIncludeAddress: null,
            itemStore: this.curCategory, 
            start: start, 
            end: end 
        }).then(res => {
            this.mountCallback(res, this.selectedResourceSync?.address || null);                             
        }).finally(() => {
            if(!checkAvailable) {
                (window as any).alertAsync('회의실 사용가능여부를 확인가능한 시간범위를 벗어났습니다.\n예약결과는 메일로 받아보실 수 있습니다.');
            }

            this.onCheckResource = false;
        })
    }

    syncSelectd() {
        var found = this.resourceItems.find(r => r.uniqueId === this.curResourceItem)
        console.log('found', found);

        if(found) {
            this.selectedResourceSync = found.itemStore === 'EWS' ? 
                (found as ewsResource.EwsResourceItem) :
                (found as reserve.DbResourceItem);
        } else {
            this.selectedResourceSync = null;
        }       
    }
}